import "core-js/modules/es.json.stringify.js";
/*
 * @Descripttion:
 * @version:
 * @Author: geory
 * @Date: 2023-08-18 15:10:26
 * @LastEditors: geory
 * @LastEditTime: 2025-09-24 18:25:38
 */
import axios from "axios";
import qs from "qs";
import store from "../store/index";
import common from "../common/js/common";
import configs from "../config/config";
import router from "../router";
import toastRegistry from "../components/Toast/index";
import vue from "vue";

// 环境的切换
let baseURL = process.env.NODE_ENV === "development" ? "http://localhost:8081/api" : "/";

// 创建axios实例
var instance = axios.create();

// 设置post请求头
instance.defaults.baseURL = baseURL;
instance.defaults.timeout = 50000;
//instance.defaults.withCredentials=true;
instance.defaults.transformRequest = [function (data) {
  //允许在向服务器发送前，修改请求数据
  data = qs.stringify(data);
  return data;
}];

//请求拦截器
instance.interceptors.request.use(
// 在发送请求之前做些什么
config => {
  let data = {
    token: localStorage.getItem("edujia:group:web:token") ? localStorage.getItem("edujia:group:web:token") : "",
    time: new Date().getTime()
  };
  config.headers = {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    app: "wmsrfpc",
    userid: localStorage.getItem("edujia:group:web:userid") ? localStorage.getItem("edujia:group:web:userid") : "",
    token: localStorage.getItem("edujia:group:web:token") ? common.encrypt(data, localStorage.getItem("edujia:group:web:key")) : ""
  };
  console.log("request config.data:", JSON.stringify(config.data));
  if (config.data && !config.isUnEncrypt) {
    let enKey = localStorage.getItem("edujia:group:web:key") ? localStorage.getItem("edujia:group:web:key") : configs.ak;
    config.data = {
      encryptData: common.encrypt(config.data, enKey)
    };
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// 响应拦截器
instance.interceptors.response.use(
// 对响应数据做点什么
// 请求成功
res => {
  console.log("res.data:", res.data);
  if (res.data && res.data.code != 200) {
    if (res.data.code == 601) {
      sessionStorage.clear();
      localStorage.clear();
      setTimeout(() => {
        window.location.reload();
      }, 100);
      if (configs.app === "wminputWeb") {
        router.replace({
          path: "/login"
        });
        // window.location.href = "/login";
      } else {
        router.replace({
          path: "/wlogin"
        });
      }
      // window.location.href="/#/login"
    } else {
      vue.prototype.$toast(res.data.message);
    }
  }
  return res.data;
},
// 请求失败
error => {
  return Promise.reject(error);
});
export default instance;